<template>
  <div id="AboutMeText2" :class="sectionClass">
    <p class="uk-text-default"
      >Inspired by the Memphis art movement of the 80’s and cartoons of the
      90’s, Nathan’s anthropomorphised graphical approach is complimented by his
      experimental use of colour, pattern, line and shape. His work spans art,
      design, illustration, installation, fashion and furniture...</p
    >
  </div>
</template>

<script>
import { isMobile } from '@/helpers'

export default {
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  padding: 0% 0% 15%;
}

.sectionMobile {
  padding: 22% 0% 35%;
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeText2.vue